import defaultProfilePicture from "static/icons/account.svg";

const getProfilePicture = (url?: string) => {
    return url || defaultProfilePicture;
};

export { getProfilePicture };
